var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnipayLogoRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_85790)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 36.364C29.0377 36.364 36.364 29.0377 36.364 20.0004C36.364 10.963 29.0377 3.63672 20.0004 3.63672C10.963 3.63672 3.63672 10.963 3.63672 20.0004C3.63672 29.0377 10.963 36.364 20.0004 36.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5073 10H13.586C11.606 10 10 11.6785 10 13.7478V27.2522C10 29.3215 11.606 31 13.586 31H26.5073C28.4872 31 30.0933 29.3215 30.0933 27.2522V13.7478C30.0933 11.6785 28.4872 10 26.5073 10ZM24.6733 24.593V24.5986C22.7415 27.2671 19.1038 27.7937 16.5506 25.7747C13.9955 23.7556 13.4916 19.9538 15.4235 17.2853C16.9565 15.1677 19.6291 14.3396 22.0186 15.2402L22.9088 14.0139L22.9195 13.999C23.3629 14.2 23.7849 14.4456 24.1801 14.7359L24.1694 14.7508L23.3112 15.9381L22.4441 17.1309L21.5841 18.32L21.5734 18.3349L18.0622 23.2011L18.0516 23.216C17.6687 22.8512 17.3856 22.386 17.2307 21.8687L17.245 21.8519L20.1116 17.8827L20.1241 17.8641L21.1016 16.5112C20.758 16.42 20.4054 16.3754 20.0529 16.3754C19.8481 16.3754 19.6433 16.3903 19.4421 16.42C17.0545 16.7717 15.3932 19.0792 15.7297 21.5728C16.0645 24.0682 18.2723 25.8044 20.66 25.4546C23.0459 25.1029 24.7089 22.7954 24.3724 20.3C24.3012 19.764 24.1374 19.2467 23.8917 18.7703L22.8946 20.1529L22.8803 20.1716L20.1045 24.0087L20.0903 24.0273H20.0351C19.5258 24.0292 19.0273 23.8915 18.5857 23.6272L18.5964 23.6123L22.0969 18.7685L22.1076 18.7536L22.9694 17.5589L23.8383 16.353L24.6983 15.1658L24.7072 15.149C25.0793 15.4747 25.4176 15.8394 25.7185 16.2358L25.706 16.2507L24.8158 17.4863C26.2384 19.6393 26.1797 22.5032 24.6733 24.593Z",
    fill: "#00535C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_85790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnipayLogoRounded);
export default __webpack_public_path__ + "static/media/earnipay-logo-rounded.079b9d6d.svg";
export { ForwardRef as ReactComponent };